module.exports = __webpack_public_path__ + "img/sup_wallet_4.3e460a5b.jpg";